module.exports = __webpack_public_path__ + "img/2.90dde6e0.png";